import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import Landing from './pages/Landing';
import Signup from './pages/Signup';
import Login from './pages/Login';
import EmailVerification from './pages/EmailVerification';
import ProfileSetup from './pages/ProfileSetup';
import EditProfile from './pages/EditProfile';
import VerifyPhoto from './pages/VerifyPhoto';
import Paywall from './pages/Paywall';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import ResetPassword from './pages/ResetPassword';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Contact from './pages/Contact';
import RefundPolicy from './pages/RefundPolicy';
import DeliveryPolicy from './pages/DeliveryPolicy';
import NotFound from './pages/NotFound';
import AuthCallback from './pages/AuthCallback';
import PaymentSuccess from './pages/PaymentSuccess';
import './App.css';

// Router component that handles OAuth callback detection
function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check for session_id in URL hash SYNCHRONOUSLY during render
  // This prevents race conditions - useLocation().hash is reactive, unlike window.location.hash
  if (location.hash?.includes('session_id=') || location.search?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/login" element={<Login />} />
      <Route path="/verify-email" element={<EmailVerification />} />
      <Route path="/profile-setup" element={<ProfileSetup />} />
      <Route path="/edit-profile" element={<EditProfile />} />
      <Route path="/verify-photo" element={<VerifyPhoto />} />
      <Route path="/paywall" element={<Paywall />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/cancellation-policy" element={<RefundPolicy />} />
      <Route path="/delivery-policy" element={<DeliveryPolicy />} />
      <Route path="/shipping-policy" element={<DeliveryPolicy />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<Navigate to="/paywall" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#1A1A2E]">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
